import { useMemo } from 'react'

import { CalculationStates, ScenarioSimple } from '@/interfaces'

import errorCodesDict from '../../../../error-codes-dictionary.json'

const errorCodesDictionary = errorCodesDict as Record<string, string>

export const useScenarioCalculationFailMessage = (
  scenarioInfo: ScenarioSimple
) => {
  return useMemo(() => {
    if (scenarioInfo.state !== CalculationStates.Error) return null

    const errorDescription =
      scenarioInfo.errorCode && errorCodesDictionary[scenarioInfo.errorCode]

    if (errorDescription) return errorDescription

    const [errorMessage] = scenarioInfo.errors || []

    return errorMessage || 'Something went wrong'
  }, [scenarioInfo])
}
